module.exports = __webpack_public_path__ + "static/media/logo-footer.73cf216f.svg";